import React from 'react';
import { Badge, Button, makeStyles } from 'design-system';
import {
  INotificationSeverity,
  INotificationSeverityColor,
} from '@scale/shared/types/notifications/notification';
import _ from 'lodash';

const useStyles = makeStyles(() => ({
  btnRoot: {
    background: 'transparent',
    textAlign: 'left',
    borderColor: 'var(--color-RemoBlue)',
  },
  btnLabel: {
    fontWeight: 'bold',
    color: 'var(--color-RemoBlue)',
  },
  badgeRoot: {
    marginLeft: 15,
    marginRight: 15,
    top: 2,
    color: '#fff',
  },
  info: {
    backgroundColor: INotificationSeverityColor.info,
  },
  warning: {
    backgroundColor: INotificationSeverityColor.warning,
  },
  action_required: {
    backgroundColor: INotificationSeverityColor.action_required,
  },
  urgent: {
    backgroundColor: INotificationSeverityColor.urgent,
  },
}));

const NotificationsBadge: React.FC<{
  onToggleCollapsed?: () => void;
  notificationCount?: Record<keyof typeof INotificationSeverity, number>;
}> = ({
  onToggleCollapsed = () => {},
  notificationCount = {
    info: 0,
    warning: 0,
    action_required: 0,
    urgent: 0,
  },
}) => {
  const classes = useStyles();
  return (
    <Button
      classes={{
        root: classes.btnRoot,
        label: classes.btnLabel,
      }}
      onClick={onToggleCollapsed}
      type="secondary"
      variant="outlined"
    >
      Notifications
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        {_.entries(notificationCount).map(([severity, count]) => (
          <Badge
            key={severity}
            classes={{
              root: classes.badgeRoot,
              badge: classes[severity as keyof typeof classes],
            }}
            className="notificationsBadge"
            max={99}
            badgeContent={count}
          />
        ))}
      </div>
    </Button>
  );
};

export default NotificationsBadge;
